import { oc } from "@orpc/contract";
import { z } from "zod";

// ─── Shared schemas ─────────────────────────────────────────────────────────

export const SupplierWarehouseConstraintRowSchema = z.object({
  id: z.string().uuid(),
  warehouseId: z.string().uuid(),
  warehouseName: z.string(),
  productGroup: z.string().nullable(),
  constraintValue: z.number().nullable(),
  constraintUom: z.string().nullable(),
  isPreferred: z.boolean(),
  activeFrom: z.string().nullable(),
  activeTo: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
});

export type SupplierWarehouseConstraintRow = z.infer<
  typeof SupplierWarehouseConstraintRowSchema
>;

// ─── List by supplier ──────────────────────────────────────────────────────

export const ListSupplierWarehouseConstraintsInputSchema = z.object({
  supplierId: z.string().uuid(),
});

export const ListSupplierWarehouseConstraintsResponseSchema = z.object({
  rows: z.array(SupplierWarehouseConstraintRowSchema),
  totalRows: z.number(),
});

export type ListSupplierWarehouseConstraintsInput = z.infer<
  typeof ListSupplierWarehouseConstraintsInputSchema
>;
export type ListSupplierWarehouseConstraintsResponse = z.infer<
  typeof ListSupplierWarehouseConstraintsResponseSchema
>;

// ─── Contract ───────────────────────────────────────────────────────────────

export const supplierWarehouseConstraintsContracts = {
  list: oc
    .input(ListSupplierWarehouseConstraintsInputSchema)
    .output(ListSupplierWarehouseConstraintsResponseSchema)
    .route({
      method: "GET",
      summary:
        "List warehouse ship-to constraints for a given supplier — which warehouses it can ship to and under what PO constraints.",
    }),
} as const;
